import { useCallback, useState } from 'react';
import fleetApi from '../../services/api.service';

/**
 * Hook custom pour désaffecter une étape d'une tournée
 * 
 * Supprime l'étape de la tournée et met à jour tour_plannings.
 * Si c'est la dernière étape du tour, supprime également la tournée.
 * 
 * @returns {Object} - { unassignStep, isUnassigning, error }
 */
const useUnassignStep = () => {
  const [isUnassigning, setIsUnassigning] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Désaffecte une étape d'une tournée
   * @param {Object} params - { tourId, stepId }
   * @returns {Promise<Object>} - Résultat de l'opération
   */
  const unassignStep = useCallback(async ({ tourId, stepId }) => {
    setIsUnassigning(true);
    setError(null);

    try {
      if (!tourId || !stepId) {
        throw new Error('Tour ID et Step ID sont requis');
      }

      const response = await fleetApi.patch(
        `/tours-planning/tours/${tourId}/steps/${stepId}/unassign`
      );

      if (response.status === 200) {
        return {
          success: true,
          message: response.data?.message || 'Étape désaffectée avec succès'
        };
      }

      throw new Error('Réponse invalide du serveur');
    } catch (err) {
      const message = 
        err?.response?.data?.message || 
        err.message || 
        "Impossible de désaffecter l'étape";
      setError(message);
      throw new Error(message);
    } finally {
      setIsUnassigning(false);
    }
  }, []);

  const resetError = useCallback(() => {
    setError(null);
  }, []);

  return {
    unassignStep,
    isUnassigning,
    error,
    resetError,
  };
};

export default useUnassignStep;


